/* src/app/invoice/pages/invoice-view-pdf/invoice-view-pdf.component.scss */
/*# sourceMappingURL=invoice-view-pdf.component.css.map */
